import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-astece',
  templateUrl: './astece.component.html',
  styleUrls: ['./astece.component.scss']
})
export class AsteceComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
